import React, { Fragment } from 'react';
import ConcessionaireDetail from './ConcessionaireDetail';

const ViewConcessionaire = () => {
    return (
        <Fragment>
            <ConcessionaireDetail />
        </Fragment>
    );
};

export default ViewConcessionaire;
